import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/meritve/drob/volna";

export const fetchWoolMeasurementPage = createAsyncThunk(
  "wool/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const fetchWoolMeasurementById = createAsyncThunk(
  "wool/byId",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(`${baseUrl}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const createWoolMeasurement = createAsyncThunk(
  "wool/create",
  async (woolMeasurement, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(baseUrl, woolMeasurement);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const updateWoolMeasurement = createAsyncThunk(
  "wool/update",
  async ({ id, woolMeasurement }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.put(`${baseUrl}/${id}`, woolMeasurement);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const woolMeasurementSlice = createSlice({
  name: "woolMeasurement",
  initialState: {
    details: null,
    page: null,
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchWoolMeasurementPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(fetchWoolMeasurementPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchWoolMeasurementPage.pending, (state, _action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchWoolMeasurementById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.details = action.payload;
      })
      .addCase(fetchWoolMeasurementById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(fetchWoolMeasurementById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createWoolMeasurement.fulfilled, (state, _) => {
        state.isLoading = false;
      })
      .addCase(createWoolMeasurement.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createWoolMeasurement.pending, (state, _) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateWoolMeasurement.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateWoolMeasurement.fulfilled, (state, action) => {
        state.isLoading = false;
        state.details = action.payload;
      })
      .addCase(updateWoolMeasurement.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default woolMeasurementSlice.reducer;
